import { State } from 'src/redux/reducer';
import { isLoaded, isPending, isRejected, shouldLoad } from 'src/redux/utils';

export const allListQuestionStatusSelector = (state: State) =>
  state.allListQuestions.status;
export const allListQuestionIdSelector = (state: State) =>
  state.allListQuestions.entities;
export const allListQuestionLoadedSelector = isLoaded(
  allListQuestionStatusSelector,
);
export const shouldLoadAllListQuestionSelector = shouldLoad(
  allListQuestionStatusSelector,
);
export const allListQuestionRejectedSelector = isRejected(
  allListQuestionStatusSelector,
);
export const allListQuestionPendingSelector = isPending(
  allListQuestionStatusSelector,
);
